import { render, staticRenderFns } from "./RequestForChangeIndicator.vue?vue&type=template&id=14f50c7a&scoped=true"
import script from "./RequestForChangeIndicator.vue?vue&type=script&lang=ts"
export * from "./RequestForChangeIndicator.vue?vue&type=script&lang=ts"
import style0 from "./RequestForChangeIndicator.scss?vue&type=style&index=0&id=14f50c7a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f50c7a",
  null
  
)

export default component.exports